export default __webpack_public_path__ + "static/media/modal-exit-wb-icon.3f0313e4.svg";